import { ApiProperty } from "@nestjs/swagger";
import { IsNotEmpty } from "class-validator";

export class StockReceiveDto {
    @ApiProperty()
    @IsNotEmpty({message:"Stock transfer id should not be empty"})
    transferLogId: number;
    @ApiProperty()
    @IsNotEmpty({message:"Received quantity should not be empty"})
    receivedQuantity: number;
    @ApiProperty()
    @IsNotEmpty({message:"Received boxes should not be empty"})
    receivedBoxes: number;
    @ApiProperty()
    @IsNotEmpty({message:"Updated user should not be empty"})
    updatedUser: string;
}